import React from 'react';
import { FormattedMessage } from 'react-intl';
import { injectIntl } from 'src/decorator/inject-intl';
import Base from 'src/core/base';

import './index.scss';

interface Prop {
    commodity: any;
}
interface State {}

@injectIntl()
export default class Detail extends Base<Prop, State> {
    constructor(prop: Prop) {
        super(prop);
    }

    render() {
        const { commodity } = this.props;
        return (
            <>
                <div className="boxs">
                    {/* <!--商品詳細-->  */}
                    <div className="detail">
                        <div className="de_cont" dangerouslySetInnerHTML={{ __html: commodity?.description }}></div>
                    </div>
                </div>
            </>
        );
    }
}
